import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.AmgVideo = class AmgVideo extends Snappy.BaseComponent {
    static get tagName() {
        return 'amg-video';
    }

    constructor(element) {
        super(element);
    }

    setVars() {
        this.Options = {
            target: this.$element.attr('id'),
            videoId: this.$element.attr('video-id'),
            amgPartnerId: this.$element.attr('amg-partner-id'),
            amgConfigId: this.$element.attr('amg-config-id'),
            videoToken: this.$element.attr('video-token'),
            randomAmg: this.$element.attr('random-amg'),
            keepItOpened: this.$element.attr('keep-it-opened')
        };
        this.playClicked = false;
        this.playBtn = $(".btn_" + this.Options.randomAmg);
        this.imageCover = $("#image_" + this.Options.randomAmg);
        this.videoPlayer = this.$element;
        this.videoItem = this.playBtn.closest(".video-item");
    }

    render() {
        this.setVars();
        
            this.setEventListeners();
       
         
    }

    setEventListeners() {
        this.playBtn.on('click', this.loadAmgVideo.bind(this));

    }

    loadAmgVideo() {
        var defaults = {};
        var settings = $.extend(this.Options, defaults);
        var playBtn = this.playBtn;
        var imageCover = this.imageCover;
        var videoPlayer = this.$element;
        var videoItem = this.videoItem;
        var element = $(this.$element)[0];
        var kdp = null;

        this.videoPlayer.addClass("is--playing");
        
        this.videoPlayer.css("z-index", "2");
        this.imageCover.css({
            "opacity": "0",
            "z-index": "0"
        });
        playBtn.css("z-index", "0");
        if (this.videoItem && settings.keepItOpened == "false") {
            this.videoItem.addClass("is--playing");
        }
        
        if (this.playClicked === false) {
            this.playClicked = true;
            if (settings.videoId !== undefined) {
                kWidget.embed({
                    'targetId': settings.target,
                    'wid': settings.amgPartnerId,
                    'uiconf_id': settings.amgConfigId,
                    'entry_id': settings.videoId,
                    "flashvars": {
                        'largePlayBtn.plugin': false,
                        "ks": settings.videoToken,
                        "autoPlay": true
                    },
                    "cache_st": 1520883895
                });


                kWidget.addReadyCallback(function (playerId) {

                    if (playerId == settings.target) {
                        kdp = document.getElementById(playerId);
                        

                        if ($(".slick-arrow")) {
                            $(".slick-arrow").click(function () {
                                kdp.sendNotification("doPause");
                            })
                        }

                        
                        playBtn.click(function () {
                            kdp.sendNotification("doPlay")
                        });

                        kdp.kBind("doPause", function () {

                            kdp.sendNotification("doPause");
                            playBtn.css("z-index", "2");
                            playBtn.css("opacity", "1");
                            if (videoItem && settings.keepItOpened == "false") {
                                videoItem.removeClass("is--playing");
                                $("#" + settings.target).css("z-index", "-1");
                                imageCover.css({
                                    "z-index": "1",
                                    "opacity": "1"
                                });
                                videoPlayer.closest(".carousel").removeClass("video--playing");
                            }
                            if (videoPlayer.closest(".carousel")) {
                                videoPlayer.closest(".carousel").slick("slickPlay");
                            }
                        });
                        kdp.kBind("doPlay", function () {

                            playBtn.css("z-index", "0");
                            $("#" + settings.target).addClass("is--playing");
                            $("#" + settings.target).css("z-index", "2");
                            imageCover.css({
                                "opacity": "0",
                                "z-index": "0"
                            });
                            if ($("#" + settings.target).closest(".carousel").length > 0) {
                                $("#" + settings.target).closest(".carousel").addClass("video--playing");
                                $("#" + settings.target).closest(".carousel").slick("slickPause");
                            }
                        });
                    }
                });
            }
        }
        
        
    }
 

}






// WEBPACK FOOTER //
// ./components/amgVideo/scripts/amg-video.js